import { Card, Col, Form, Input, Row } from 'antd';
import FloatingFormItem from '../../FloatingFormItem';
import { VehicleFormData } from '@/core/domain/people/CustomerVehicles/CustomerVehicles.types';
import { useDefaultMaxLengthFieldError } from '@/hooks';

interface Props {
  disabledFields?: boolean;
}

export default function VehiclAdditionalInformationForm({
  disabledFields = false,
}: Props) {
  const form = Form.useFormInstance<VehicleFormData>();
  const formValues = Form.useWatch([], form);
  const searchBy = Form.useWatch('searchBy', form);

  const defaultMaxLenghtFieldError = useDefaultMaxLengthFieldError();

  const hasLicensePlate = !!formValues?.licensePlate;
  const hasChassi = !!formValues?.chassi && formValues.chassi.length === 17;

  const handlerDisableFields =
    searchBy === 'Placa' ? !hasLicensePlate : !hasChassi;

  const disabled = disabledFields || handlerDisableFields;

  return (
    <Card title="Informações complementares">
      <Row gutter={[12, 12]}>
        <Col span={24} md={8} lg={5}>
          <FloatingFormItem
            name="line"
            label="Linha"
            rules={[defaultMaxLenghtFieldError(100)]}
          >
            <Input disabled={disabled} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={5}>
          <FloatingFormItem
            name="transmissionType"
            label="Tipo de transmissão"
            rules={[defaultMaxLenghtFieldError(100)]}
          >
            <Input disabled={disabled} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={5}>
          <FloatingFormItem
            name="airIntake"
            label="Entrada de ar"
            rules={[defaultMaxLenghtFieldError(100)]}
          >
            <Input disabled={disabled} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={5}>
          <FloatingFormItem
            name="brakeSystem"
            label="Sistema de freios"
            rules={[defaultMaxLenghtFieldError(100)]}
          >
            <Input disabled={disabled} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={4}>
          <FloatingFormItem
            name="steeringSystem"
            label="Sistema de direção"
            rules={[defaultMaxLenghtFieldError(100)]}
          >
            <Input disabled={disabled} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={5}>
          <FloatingFormItem
            name="tractionSystem"
            label="Sistema de tração"
            rules={[defaultMaxLenghtFieldError(100)]}
          >
            <Input disabled={disabled} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={5}>
          <FloatingFormItem
            name="injectionSystem"
            label="Sistema de injeção"
            rules={[defaultMaxLenghtFieldError(100)]}
          >
            <Input disabled={disabled} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={5}>
          <FloatingFormItem
            name="engineConfiguration"
            label="Configuração do motor"
            rules={[defaultMaxLenghtFieldError(100)]}
          >
            <Input disabled={disabled} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={5}>
          <FloatingFormItem
            name="rearBrake"
            label="Freio traseiro"
            rules={[defaultMaxLenghtFieldError(100)]}
          >
            <Input disabled={disabled} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={4}>
          <FloatingFormItem
            name="frontBrake"
            label="Freio dianteiro"
            rules={[defaultMaxLenghtFieldError(100)]}
          >
            <Input disabled={disabled} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Card>
  );
}
